module.exports = __webpack_public_path__ + "img/import_data_icon128x128.9ecbf1df.png";